export default function ContactSection() {
  return (
    <section className="w-full py-20 bg-white">
      <div className="max-w-6xl mx-auto text-center px-4" data-aos="fade-up">

        <h2 className="text-3xl font-bold text-[#1A1F2B]">Visit Us</h2>

        <p className="text-gray-700 mt-3">
          Moriah Church, New Delhi • We welcome everyone
        </p>

        {/* Map */}
        <div className="mt-10 w-full h-72 rounded-xl overflow-hidden" data-aos="fade-up">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4345.761557150322!2d77.13167381172667!3d28.62539428430213!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d03ba48420ba3%3A0x7fa04e7b22470c0d!2zTU9SSUFIIENIVVJDSCAo4KSq4KWN4KSw4KS-4KSw4KWN4KSl4KSo4KS-IOCkreCkteCkqCk!5e1!3m2!1sen!2sin!4v1765477469125!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map showing church location"
          ></iframe>
        </div>

      </div>
    </section>
  );
}
